var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ExpedienteService } from '../../services/expediente.service';
import { KeycloakService } from '../../services/keycloak.service';
import { Signer, SIGNER_STATUS } from '../../common/firmador/firma-helper.component';
import { Escrito } from '../../model/escrito';
import { ServiceException } from '../../model/exception';
import { CommonService } from '../../services/common.service';
import { Pager } from '../../common/pager/pager.component';
import { Message } from '../../common/dialog/mensaje.component';
import { MensajeConfig } from '../../common/dialog/mensaje.config';
import { SharedService } from '../../services/shared.service';
var EscritoPresentarComponent = (function () {
    function EscritoPresentarComponent(_service, _comService, sanitizer) {
        this._service = _service;
        this._comService = _comService;
        this.sanitizer = sanitizer;
        this.showWarn = false;
        this.PRESIGN = 1;
        this.SIGNING = 2;
        this.POSTSIGN = 3;
        this.onStatusChange = new EventEmitter(false);
        this.visible = false;
        this.aliases = [];
        this.cns = [];
        this.escrito = new Escrito();
        this.estado = this.PRESIGN;
        this.statusMessage = '';
        this.adjuntos = [];
        this.discert = true;
        this.uploadCounter = 0;
        this.images = [];
        this.pageNumber = 0;
        this.mensajeCert = 'Cargando Certificados, aguarde por favor';
    }
    EscritoPresentarComponent.prototype.open = function (esc, filename, fileId) {
        var _this = this;
        // console.log("loading escrito de exp " + JSON.stringify(esc) + ", file=" + fileId + ", name=" + filename);
        // var that = this;
        this.signer = new Signer(fileId, 'escrito');
        this.aviso = this._comService.getConfiguracion('AVISOACT');
        this.signer.onAliasOk.subscribe(function (event) {
            _this.aliases = _this.signer.aliases;
            _this.discert = false;
            _this.cns = _this.signer.commonNames;
            _this.mensajeCert = 'Seleccione un Certificado';
            // console.log("certificados " + JSON.stringify(this.cns));
        });
        this.signer.onSignOk.subscribe(function (event) { _this.save(); });
        this.signer.onError.subscribe(function (event) { _this.error(); });
        this.escrito = esc;
        this.fileId = fileId;
        this.filename = filename;
        this.getTextoEsc(0);
        this.statusMessage = "";
        this.estado = this.PRESIGN;
        this.visible = true;
    };
    // tslint:disable-next-line:no-inferrable-types
    EscritoPresentarComponent.prototype.getTextoEsc = function (page) {
        var _this = this;
        if (page === void 0) { page = 0; }
        var that = this;
        this._service.getFilePreview(btoa(SharedService.unescape(encodeURIComponent(this.fileId + '/' + this.filename))), page).subscribe(function (response) {
            // this.pr:qeviewEscrito = this.sanitizer.bypassSecurityTrustResourceUrl("data:application/pdf;base64," + response.data);
            var i = 0;
            that.images = [];
            response.data.split(',').forEach(function (image) {
                that.images[i++] = _this.sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,'
                    + image);
            });
            _this.showWarn = response.isJpx;
            //console.log('pages received (' + response.isJpx + ')' + this.images.length);
            setTimeout(function () { return _this._comService.emitBlocking(false); }, 1000);
            _this.previewEscrito = true;
            _this.pageNumber = response.pages;
            try {
                _this.scrollable.nativeElement.scrollTop = 0;
            }
            catch (error) {
            }
            if (_this.pager) {
                _this.pager.setLock(false);
            }
        });
    };
    EscritoPresentarComponent.prototype.gotoPage = function (page) {
        //console.log('goto ' + page);
        this.pager.setLock(true);
        this.getTextoEsc(page);
    };
    EscritoPresentarComponent.prototype.reset = function () {
        this.aliases = [];
        this.selectedAlias = '';
        this.adjuntos = [];
        this.adjMap = [];
    };
    EscritoPresentarComponent.prototype.onChange = function (event) {
        var _this = this;
        this.msgPopup.onClick.subscribe(function (event) { _this.onOk(event); });
        //console.log('setting ' + this.adjuntos.length + ' attachs');
        //console.log('atach ' + event.target.files[0].name);
        if (event.target.files.length > 0) {
            this.adjuntos = this.adjuntos.concat([].slice.call(event.target.files));
            var cant_ini = this.adjuntos.length;
            this.adjuntos = this.removeDuplicates(this.adjuntos);
            var cant_fin = this.adjuntos.length;
            if (cant_ini !== cant_fin) {
                this.onRepetido('El archivo ya se adjuntó.');
            }
            //console.log('ADJUNTOS ' + JSON.stringify(this.adjuntos));
            this.armarAdjuntos(this.adjuntos);
            //console.log(this.adjuntos.length + ' attachs');
        }
    };
    EscritoPresentarComponent.prototype.removeDuplicates = function (originalArray) {
        var hash = {};
        originalArray = originalArray.filter(function (current) {
            // let exists = !hash[current.name.substring(0, current.name.indexOf('.'))] || false;
            // hash[current.name.substring(0, current.name.indexOf('.'))] = true;
            var exists = !hash[current.name] || false;
            hash[current.name] = true;
            return exists;
        });
        return originalArray;
    };
    EscritoPresentarComponent.prototype.onRepetido = function (sms, tit) {
        if (tit === void 0) { tit = 'Carga de Adjuntos'; }
        this.mensajeConfigSource = new MensajeConfig(tit, false, '', true, 'Aceptar');
        this.msgPopup.showMessage(sms);
    };
    EscritoPresentarComponent.prototype.onOk = function (res) {
        //console.log('cerro ');
    };
    EscritoPresentarComponent.prototype.onClickHab = function (ev) {
        // console.log("click fav" + ev);
        this.escrito.conHabDiaHora = !this.escrito.conHabDiaHora;
    };
    EscritoPresentarComponent.prototype.armarAdjuntos = function (adj) {
        this.adjMap = [];
        for (var i = 0; adj.length > 4; i++) {
            this.adjMap[i] = [];
            this.adjMap[i] = adj.splice(0, 4);
        }
        this.adjMap[this.adjMap.length] = adj;
        this.adjuntos = this.concatAdjuntos();
    };
    EscritoPresentarComponent.prototype.concatAdjuntos = function () {
        var concatAdj = [];
        for (var i = 0; i < this.adjMap.length; i++) {
            concatAdj = concatAdj.concat([].slice.call(this.adjMap[i]));
        }
        return concatAdj;
    };
    EscritoPresentarComponent.prototype.deleteFile = function (index1, index2) {
        // var concatAdj:any[] = this.concatAdjuntos();
        var indice = index1 * 4 + index2;
        this.adjuntos.splice(indice, 1);
        this.armarAdjuntos(this.adjuntos);
    };
    EscritoPresentarComponent.prototype.fileChangeEvent = function (fileInput) {
        //console.log("fileChange " + JSON.stringify(fileInput.target.files));
        if (fileInput.target.files.length > 0) {
            //console.log("uploading files: " + fileInput.target.files.length);
            //console.log("uploading files names: " + JSON.stringify(fileInput.target.files));
            var reader = new FileReader();
            var that = this;
            var fileName64 = fileInput.target.files[0].name;
            fileName64 = fileName64.replace(/[\u00A0-\u2666\u00F1\u00D1]/g, function (c) {
                return '&#' + c.charCodeAt(0) + ';';
            });
            //console.log("REMPALAZO NAME FILE " + fileInput.target.files[0].name + " TO " + fileName64);
            var ext = fileName64.substring(fileName64.indexOf("."));
            //console.log("extension file " + ext);
            //console.log("name sin extension " + fileName64.substring(0, fileName64.indexOf(".")));
            //console.log("no mas de 30 " + fileName64.substring(0, fileName64.indexOf(".")).substring(0, 15));
            fileName64 = fileName64.substring(0, fileName64.indexOf(".")) + ext;
            reader.onloadend = function () {
                that._service.uploadAdjunto(that.fileId, "adjunto;" + fileName64, reader.result).subscribe(function (result) {
                    //console.log("upload: " + JSON.stringify(result));
                }, function (error) {
                    console.error(error);
                    alert(error);
                });
            };
            if (fileInput.target.files[0]) {
                reader.readAsDataURL(fileInput.target.files[0]);
            }
        }
        else {
            // cancelado
        }
    };
    EscritoPresentarComponent.prototype._keyPress = function (event) {
        //const pattern = /[a-zA-Z0-9 ]/;
        //const pattern =  /[a-zA-Z0-9 ñÑÁÉÍÓÚÜüñáéíóú]/;
        var pattern = /[/\\:*?"<>|]/;
        var inputChar = String.fromCharCode(event.charCode);
        if (event.charCode != 0 && pattern.test(inputChar)) {
            event.preventDefault();
        }
    };
    EscritoPresentarComponent.prototype.adjuntosUpload = function () {
        //console.log("upload: " + JSON.stringify(this.fileId));
        var concatAdj = [];
        if (this.adjMap != null) {
            for (var i = 0; i < this.adjMap.length; i++) {
                concatAdj = concatAdj.concat([].slice.call(this.adjMap[i]));
            }
        }
        this.doSyncUpload(concatAdj);
    };
    EscritoPresentarComponent.prototype.doSyncUpload = function (data) {
        //console.log("sync uploading ..." + data.length);
        this.uploadCounter = 0;
        if (data.length > 0) {
            this._comService.emitBlocking(true);
            for (var i = 0; data.length > i; i++) {
                this.setupAdjReader(data[i], this.fileId, data.length);
            }
        }
        else {
            this.firmar();
        }
    };
    EscritoPresentarComponent.prototype.signIfReady = function (when) {
        if (when <= 0) {
            //console.log("firmando ...");
            this.firmar();
        }
    };
    EscritoPresentarComponent.prototype.setupAdjReader = function (file, id, total) {
        var name = file.name;
        var reader = new FileReader();
        var that = this;
        //console.log("uploading " + name + " ...");
        var fileName64 = name;
        fileName64 = fileName64.replace(/[\u00A0-\u2666\u00F1\u00D1]/g, function (c) {
            return '&#' + c.charCodeAt(0) + ';';
        });
        //console.log("REMPALAZO NAME FILE " + name + " TO " + fileName64);
        var ext = fileName64.substring(fileName64.indexOf("."));
        //console.log("extension file " + ext);
        //console.log("name sin extension " + fileName64.substring(0, fileName64.indexOf(".")));
        //console.log("no mas de 30 " + fileName64.substring(0, fileName64.indexOf(".")).substring(0, 15));
        fileName64 = fileName64.substring(0, fileName64.indexOf(".")) + ext;
        reader.onloadend = function () {
            that._service.uploadAdjunto(id, "adjunto;" + fileName64, reader.result).subscribe(function (result) {
                //console.log("adjunto subido: " + name);
                that.uploadCounter++;
                that.signIfReady(total - that.uploadCounter);
            }, function (error) {
                console.error(error);
                alert(error);
            });
        };
        reader.readAsDataURL(file);
    };
    EscritoPresentarComponent.prototype.firmar = function () {
        this.estado = this.SIGNING;
        this._comService.emitBlocking(false);
        //console.log("firmando con " + this.selectedAlias + " ...");
        this.signer.doSign(this.selectedAlias);
    };
    EscritoPresentarComponent.prototype.onChangeSelectAliases = function (selected) {
        var index = this.aliases.indexOf(selected);
        //console.log("firmante " + this.cns[index]);
        this.selectedAlias = selected;
    };
    EscritoPresentarComponent.prototype.save = function () {
        var _this = this;
        this.escrito.usuCodigo = KeycloakService.getLoggedUser();
        this._service.saveSignatures(this.fileId, this.escrito).subscribe(function (response) {
            if (JSON.stringify(response).indexOf("error") > -1) {
                _this.onStatusChange.emit(SIGNER_STATUS.ERROR.code);
                _this.statusMessage = "No se pudo guardar el escrito y su firma. Por favor, reintente la operación. Gracias";
            }
            else {
                _this.statusMessage = "Escrito firmado y guardado.";
                _this.onStatusChange.emit(SIGNER_STATUS.SIGNOK.code);
                _this.finalize();
            }
        }, function (error) {
            var exc = ServiceException.parse(error.json());
            //console.log(exc.description);
            _this.statusMessage = "No se pudo guardar el escrito (" + exc.errorCode + "). Por favor, reintente la operación. Gracias";
        });
        this.estado = this.POSTSIGN;
    };
    EscritoPresentarComponent.prototype.finalize = function () {
        this.images = [];
        this.previewEscrito = false;
        if (this.visible && this.signer) {
            this.reset();
            this.visible = false;
            this.previewEscrito = null;
            if (this.signer) {
                this.signer.close();
            }
            this.signer.finalize();
            this.signer = null;
            this.statusMessage = "";
            this.estado = this.PRESIGN;
            this.onStatusChange.emit(SIGNER_STATUS.CLOSED.code);
        }
        if (this.pager) {
            this.pager.pcount = 0;
        }
    };
    EscritoPresentarComponent.prototype.error = function () {
        console.warn("WARNING: " + this.signer.getStatus().message);
        if (this.signer.getStatus().message.toUpperCase().indexOf("CKR_FUNCTION_CANCELED") > -1) {
            // ingreso de pin cancelado
            this.finalize();
        }
    };
    EscritoPresentarComponent.prototype.isFirmarDisabled = function () {
        return (!this.selectedAlias || this.selectedAlias === "-1")
            || (!this.escrito.titulo || this.escrito.titulo.trim().length == 0);
    };
    EscritoPresentarComponent.prototype.ngOnDestroy = function () {
        // this.finalize();
    };
    return EscritoPresentarComponent;
}());
__decorate([
    ViewChild(Message),
    __metadata("design:type", Message)
], EscritoPresentarComponent.prototype, "msgPopup", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], EscritoPresentarComponent.prototype, "onStatusChange", void 0);
__decorate([
    ViewChild('scrollable'),
    __metadata("design:type", ElementRef)
], EscritoPresentarComponent.prototype, "scrollable", void 0);
__decorate([
    ViewChild(Pager),
    __metadata("design:type", Pager)
], EscritoPresentarComponent.prototype, "pager", void 0);
EscritoPresentarComponent = __decorate([
    Component({
        moduleId: module.id,
        selector: 'escrito-presentar',
        templateUrl: 'escrito-presentar.component.html',
    }),
    __metadata("design:paramtypes", [ExpedienteService, CommonService,
        DomSanitizer])
], EscritoPresentarComponent);
export { EscritoPresentarComponent };
//# sourceMappingURL=escrito-presentar.component.js.map